<template>
  <section
    v-if="documents && documents.length"
    class="client-cabinet-plain-section client-cabinet-documents"
    aria-labelledby="client-page-documents-title"
    data-testid="client-page-documents"
  >
    <h2 id="client-page-documents-title" class="text-h6 mb-2">{{ $t("client_page.cabinet.documents.title") }}</h2>
    <ul class="client-cabinet-list">
      <li
        v-for="(doc, index) in rows"
        :key="index"
        class="client-cabinet-row"
        data-testid="client-page-document"
        data-field="booking.generated_documents[].okidoki_status booking.generated_documents[].okidoki_link booking.generated_documents[].docuseal_status booking.generated_documents[].docuseal_client_link booking.generated_documents[].docuseal_client_signed_at booking.generated_documents[].download_url booking.generated_documents[].link"
      >
        <span>
          <span class="d-block" data-field="booking.generated_documents[].name">{{ doc.name || $t("client_page.cabinet.documents.untitled") }}</span>
          <span class="text-body-2 client-cabinet-muted" data-field="booking.generated_documents[].created_at">
            {{ $t(doc.statusKey) }}<template v-if="doc.date"> · {{ doc.date }}</template>
          </span>
        </span>
        <a v-if="doc.signLink" :href="doc.signLink" target="_blank" rel="noopener" class="client-cabinet-link client-cabinet-link--button">
          {{ $t("client_page.cabinet.documents.sign") }}
        </a>
        <a v-else-if="doc.downloadUrl" :href="doc.downloadUrl" target="_blank" rel="noopener" class="client-cabinet-link client-cabinet-link--button">
          {{ $t("client_page.cabinet.documents.download") }}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
// FT-200 STEP-05 (REQ-08): документы бронирования — название, статус, текстовая кнопка «Подписать» или «Скачать».
// Скачать — download_url ответа (полный адрес хранилища), без него — ключ link через s3PublicUrl, как в старом кабинете.
import { s3PublicUrl } from "@/utils/s3PublicUrl";
import { documentStatusKey, formatCabinetDate, signLink } from "@/utils/clientCabinetView";

export default {
  name: "DocumentsBlock",
  props: {
    documents: { type: Array, default: () => [] },
  },
  computed: {
    rows() {
      return (this.documents || []).map((doc) => ({
        name: doc.name,
        date: formatCabinetDate(doc.created_at, (this.$i18n && this.$i18n.locale) || "ru", "D MMMM"),
        statusKey: documentStatusKey(doc),
        signLink: signLink(doc),
        downloadUrl: doc.download_url || (doc.link ? s3PublicUrl(doc.link) : null),
      }));
    },
  },
};
</script>
